import './index.erb';
import './index.rb';
import './index.scss';

(function ($) {
  'use strict';
  const $lastRelateds = $('.last-related');
  const $btnViewMoreRelateds = $('#more-related');
  const $btnViewLessRelateds = $('#less-related');
  $btnViewMoreRelateds.click(() => {
    $btnViewMoreRelateds.hide();
    $lastRelateds.show();
  });

  $btnViewLessRelateds.click(() => {
    $lastRelateds.hide();
    $btnViewMoreRelateds.show();
  });
})(jQuery);
